import cx from 'classnames'
import PropTypes from 'prop-types'
import './styles.scss'

const UserIcon = ({ enabled, internal }) => (
  <span
    className={cx('eleo-user-icon grid aspect-square', {
      active: enabled,
      inactive: !enabled,
      internal,
      external: !internal,
    })}
  />
)

UserIcon.defaultProps = {
  enabled: true,
  internal: true,
}

UserIcon.propTypes = {
  enabled: PropTypes.bool,
  internal: PropTypes.bool,
}

export default UserIcon
